import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import SelectBoxViewModelType from '@/ViewModels/Controls/SelectBoxViewModel';

export default class SelectBox extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: SelectBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<ul>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'selectbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            focus: this.viewModel.isFocusable,

            invalid: this.viewModel.invalidationText,

            selectBoxItems: {
                parent: self,

                items: this.viewModel.items
            },

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });
    }
}

ComponentManager.setControl('SelectBox', SelectBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');